import { render, staticRenderFns } from "./port-system-match-add.vue?vue&type=template&id=d85abec8&"
import script from "./port-system-match-add.vue?vue&type=script&lang=js&"
export * from "./port-system-match-add.vue?vue&type=script&lang=js&"
import style0 from "./port-system-match-add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports